import { useSelector } from "react-redux";

const usePartnerFileUpload = () => {
  const partnerFileUpload = useSelector((state) => state.partnerFileData);

  const { utilityData } = partnerFileUpload.utility;
  const { adminEngagementData } = partnerFileUpload.adminEngagement;
  const { adminFilesData } = partnerFileUpload.adminFiles;
  const { adminOriginalFileNamesData } = partnerFileUpload.adminOriginalFileNames;
  const { partnersFilesDeleteData } = partnerFileUpload.partnersFilesDelete;
  const { partnersEditEngagementDetailsData } =
    partnerFileUpload.partnersEditEngagementDetails;
  const { partnersFileValidationData } =
    partnerFileUpload.partnersFileValidation;
  const { filesEngagementData } = partnerFileUpload.filesEngagement;
  const { partnerFilesBlocklistData } = partnerFileUpload.partnerFilesBlocklist;
  const { partnersViewFilesContentData } =
    partnerFileUpload.partnersViewFilesContent;
    const {partnersDeleteTempFilesOnPopupCloseData} = partnerFileUpload.partnersDeleteTempFilesOnPopupClose;
  const {partnersDownloadFilesContentData}=partnerFileUpload.partnersDownloadFilesContent;
  const {partnersEditEngagementStatusData} = partnerFileUpload.partnersEditEngagementStatus;
  const {partnersSasTokenData} = partnerFileUpload.partnersSasToken;
  const {partnersUploadProcessingData} = partnerFileUpload.partnersUploadProcessing;
   const {partnersUploadReProcessingData} = partnerFileUpload.partnersUploadReProcessing;
  const {partnersUploadSharePointFilesToBlobData} = partnerFileUpload.partnersUploadSharePointFilesToBlob;
  const {partnersAccessGrantData} = partnerFileUpload.partnersAccessGrant;
  const {partnersAccessRevokeData} = partnerFileUpload.partnersAccessRevoke;
  const { adminDownloadFileData } = partnerFileUpload.adminDownloadFile;
  const { adminExportExcelData } = partnerFileUpload.adminExportExcel;
  const { adminStartAnonymizationData } = partnerFileUpload.adminStartAnonymization;
  const { adminBookmarkFileData } = partnerFileUpload.adminBookmarkFile || { adminBookmarkFileData: { data: {}, status: null, error: null } };
  const adminManualUploadData = partnerFileUpload.adminManualUpload || { data: {}, status: null, error: null };
  const {partnersUploadedFileStatusData} = partnerFileUpload.partnersUploadedFileStatus;
  const {partnersDuplicateFilesData} = partnerFileUpload.partnersDuplicateFiles;
  const {partnersEnableDisableClientData} = partnerFileUpload.partnersEnableDisableClient;
  const {partnersErrorSaveData} = partnerFileUpload.partnersErrorSave;
  const {plannedOutagePriorData} = partnerFileUpload.plannedOutagePrior || { plannedOutagePriorData: { data: null, status: null, error: null } };
  const {plannedOutageActiveData} = partnerFileUpload.plannedOutageActive || { plannedOutageActiveData: { data: null, status: null, error: null } };
  const {partnersDownloadArcArchivesData} = partnerFileUpload.partnersDownloadArcArchives || { partnersDownloadArcArchivesData: { data: {}, status: null, error: null } };

  return {
    utilityData,
    adminEngagementData,
    adminFilesData,
    partnersFilesDeleteData,
    partnersEditEngagementDetailsData,
    partnersFileValidationData,
    filesEngagementData,
    partnerFilesBlocklistData,
    partnersViewFilesContentData,
    partnersDeleteTempFilesOnPopupCloseData,
    partnersDownloadFilesContentData,
    partnersEditEngagementStatusData,
    partnersSasTokenData,
    partnersUploadProcessingData,
     partnersUploadReProcessingData,
    partnersUploadSharePointFilesToBlobData,
    partnersAccessGrantData,
    partnersAccessRevokeData
    ,adminDownloadFileData
    ,adminExportExcelData
    ,adminOriginalFileNamesData
    ,adminStartAnonymizationData
  ,adminManualUploadData
    ,adminBookmarkFileData,
    partnersUploadedFileStatusData,
  partnersDuplicateFilesData,
  partnersEnableDisableClientData,
  partnersErrorSaveData,
  plannedOutagePriorData,
  plannedOutageActiveData,
  partnersDownloadArcArchivesData
  };
};

export default usePartnerFileUpload;
